import axios from 'axios';

export function adminCreateCampaign(advertiserId, payload, token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/advertisers/${advertiserId}/campaigns`,
        payload,
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
